import { RefObject, useCallback } from 'react';

import { useInViewportEffect } from './useInViewportEffect';

type Props<T extends HTMLElement> = {
  ref: RefObject<T>;
  threshold?: number;
  offset?: {
    left?: number;
    right?: number;
    top?: number;
    bottom?: number;
  };
  onReach: () => void;
};

/**
 * Triggers onReach the first time the element is visible in the
 * viewport
 */
export function useElementReachedEffect<T extends HTMLElement>({
  ref,
  offset,
  threshold,
  onReach,
}: Props<T>): void {
  useInViewportEffect({
    ref,
    threshold,
    offset,
    freezeOnceVisible: true,
    callback: useCallback(
      ({ inViewport }) => {
        if (inViewport) onReach();
      },
      [onReach]
    ),
  });
}
